"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { PaymentController } from "@/service/newProdect";
import { Component, PropSync, Vue } from "vue-property-decorator";
let PaymentNewDateOptions = class extends Vue {
  constructor() {
    super(...arguments);
    this.name = "PaymentNewDateOptions";
  }
  paymentOptionsChange() {
    this.$emit("paymentOptionsChange");
  }
};
__decorateClass([
  PropSync("options", { default: function() {
    return new PaymentController();
  } })
], PaymentNewDateOptions.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", { type: String, default: function() {
    return "create";
  } })
], PaymentNewDateOptions.prototype, "payment_style", 2);
PaymentNewDateOptions = __decorateClass([
  Component
], PaymentNewDateOptions);
export {
  PaymentNewDateOptions as default
};
